import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../mock";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Soft gradient backdrop */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-cream via-brand-sand to-[#EFE7DA]" />
      <div className="absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full bg-brand-lavender/25 blur-3xl" />
      <div className="absolute bottom-0 -left-32 w-[460px] h-[460px] rounded-full bg-brand-goldLight/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 pt-28 lg:pt-32 pb-20 lg:pb-20 grid lg:grid-cols-2 gap-14 lg:gap-14 items-center w-full">
        <div className="order-2 lg:order-1">
          <p className="text-xs tracking-[0.4em] uppercase text-brand-gold mb-5 sm:mb-6">
            {t.hero.kicker}
          </p>
          <h1 className="font-serif text-[2.75rem] leading-[1.08] sm:text-6xl md:text-7xl sm:leading-[1.05] text-brand-plumDark mb-6 sm:mb-7">
            {t.hero.title}
          </h1>
          <p className="text-base sm:text-lg text-brand-ink/75 leading-relaxed max-w-xl mb-8 sm:mb-10">
            {t.hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-4">
            <button
              onClick={() => scrollTo("pranic")}
              className="group inline-flex items-center justify-center gap-2 bg-brand-plum hover:bg-brand-plumDark text-brand-cream px-7 py-4 sm:py-3.5 rounded-full transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
            >
              {t.hero.cta1}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center justify-center gap-2 border border-brand-plum/40 text-brand-plum hover:bg-brand-plum hover:text-brand-cream px-7 py-4 sm:py-3.5 rounded-full transition-all duration-300"
            >
              {t.hero.cta2}
            </button>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 mb-8 lg:mb-0">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_80px_rgba(76,62,99,0.18)] lg:float-slow">
            <img
              src={IMAGES.hero}
              alt="Energia e serenità"
              className="w-full h-[360px] sm:h-[460px] lg:h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-plumDark/25 to-transparent" />
          </div>
          <div className="absolute -bottom-6 left-4 sm:-bottom-8 sm:-left-8 bg-white/90 backdrop-blur rounded-2xl px-5 py-4 sm:px-6 sm:py-5 shadow-xl border border-brand-sand max-w-[220px]">
            <p className="font-serif text-3xl text-brand-gold leading-none">✦</p>
            <p className="text-sm text-brand-ink/70 mt-2 leading-snug">
              {t.about.quote}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
